module.exports = "pegasus/assets/blocks/column-lp1-themelp1.png";